<template>
  <div>
    <!-- Ecran de connexion -->
    <b-modal
      id="modal-connexion"
      title="Connexion"
      @ok="handleOkConnexion"
      ok-title="Valider"
      cancel-title="Annuler"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div>
          <b-card no-body>
            <b-tabs card content-class="mt-3" fill v-model="tabIndex">
              <b-tab title="Identification">
                <b-card-text
                  >Indiquez votre adresse mail et votre mot de passe pour vous
                  connecter.</b-card-text
                >
                <b-form-input
                  id="input-email"
                  v-model="email"
                  placeholder="Email"
                  type="email"
                  :state="emailState"
                ></b-form-input>
                <b-form-input
                  id="input-mdp"
                  v-model="mdp"
                  placeholder="Mot de passe"
                  type="password"
                  :state="mdpState"
                ></b-form-input>
                <b-button @click="genererMotDePasse"
                  >Mot de passe oublié</b-button
                >
              </b-tab>
              <b-tab title="Nouveau client">
                <b-card-text
                  >Indiquez votre adresse mail, choisissez un mot de passe afin
                  de créer votre compte client.</b-card-text
                >
                <b-form-input
                  v-model="email"
                  placeholder="Email"
                  type="email"
                  :state="emailState"
                ></b-form-input>
                <b-form-input
                  v-model="mdp"
                  :state="newMdpState"
                  placeholder="Mot de passe"
                  type="password"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback"
                  >Le mot de passe doit au comporter au minimum 6
                  caractères</b-form-invalid-feedback
                >
                <b-form-input
                  v-model="mdp2"
                  :state="newMdp2State"
                  placeholder="Mot de passe (confirmation)"
                  type="password"
                ></b-form-input>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </form>
    </b-modal>
    <!-- Ecran de changement de mot de passe -->
    <b-modal
      id="modal-mdpclient"
      title="Modification du mot de passe"
      @ok="handleOkModifMdp"
      @cancel="handleCancelModifMdp"
      okTitle="Enregistrer"
      cancelTitle="Annuler"
    >
      <form>
        <b-form-input
          id="input-mdp-actuel"
          v-model="mdpActuel"
          :state="mdpActuelState"
          placeholder="Mot de passe actuel"
          type="password"
        ></b-form-input>
      </form>
      <b-form-input
        v-model="mdp"
        :state="newMdpState"
        placeholder="Nouveau mot de passe"
        type="password"
      ></b-form-input>
      <b-form-invalid-feedback id="input-live-feedback"
        >Le mot de passe doit au comporter au minimum 6
        caractères</b-form-invalid-feedback
      >
      <b-form-input
        v-model="mdp2"
        :state="newMdp2State"
        placeholder="Nouveau mot de passe (confirmation)"
        type="password"
      ></b-form-input>
    </b-modal>
    <!-- Ecran de gestion du compte -->
    <b-modal
      id="modal-compteclient"
      title="Compte client"
      @ok="handleOk"
      okTitle="Enregistrer"
      cancelTitle="Annuler"
    >
      <form
        ref="form-compteclient"
        @submit.stop.prevent="handleSubmitCompteClient"
      >
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Civilité"
          label-for="select-civ"
        >
          <b-form-select
            id="select-civ"
            v-model="user.idCivilite"
            :options="listeCivilités"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          :state="nomState"
          invalid-feedback="Saisie obligatoire"
          label-cols="4"
          label-cols-lg="2"
          label="Nom"
          label-for="input-nom"
        >
          <b-form-input
            id="input-nom"
            :state="nomState"
            required
            v-model="user.nom"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Prenom"
          label-for="input-prenom"
        >
          <b-form-input id="input-prenom" v-model="user.prenom"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Adresse"
          label-for="input-adresse"
        >
          <b-form-input
            id="input-adresse"
            v-model="user.adresse"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="CP"
          label-for="input-cp"
        >
          <vue-bootstrap-typeahead
            ref="thCP"
            class="mb-4"
            v-model="cpEnCours"
            :data="listeCommunes"
            :serializer="(item) => item.codecity"
            @hit="selectionListeCommune($event)"
          ></vue-bootstrap-typeahead>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Ville"
          label-for="input-ville"
        >
          <vue-bootstrap-typeahead
            ref="thVille"
            class="mb-4"
            v-model="villeEnCours"
            :data="listeCommunes"
            :serializer="(item) => item.codecity"
            @hit="selectionListeCommune($event)"
          ></vue-bootstrap-typeahead>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Mail"
          label-for="input-mail"
        >
          <b-form-input id="input-mail" v-model="email" disabled></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label="Tel"
          label-for="input-tel"
        >
          <b-form-input id="input-tel" v-model="user.telephone"></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
const apiUrl = process.env.VUE_APP_API_URL;
const axios = require("axios").default;

export default {
  computed: {
    emailState() {
      if (this.email.length === 0) {
        return null;
      } else {
        var domaine = this.email.split("@");
        if (domaine.length > 1) {
          var posPoint = domaine[1].indexOf(".");
          return posPoint > 0 && posPoint < domaine[1].length - 1;
        } else {
          return false;
        }
      }
    },
    nomState() {
      return this.user.nom.length > 0 ? null : false;
    },
    mdpActuelState() {
      return this.mdpActuel.length > 0 ? null : false;
    },
    newMdpState() {
      return this.mdp.length > 5 ? null : false;
    },
    newMdp2State() {
      return this.mdp2 === this.mdp ? null : false;
    },
  },

  data() {
    return {
      // Connexion
      email: "",
      mdpActuel: "",
      mdp: "",
      mdp2: "",
      tabIndex: 0,
      mdpState: "",
      user: {
        email: "",
        idUser: "",
        idCivilite: "",
        civilite: "",
        nom: "",
        prenom: "",
        adresse: "",
        cp: "",
        ville: "",
        telephone: "",
      },
      // Fiche client
      listeCivilités: [],
      listeCommunes: [],
      selectionCommune: "",
      id: 0,
      idCivilité: 0,
      civilité: "",
      nom: "",
      prenom: "",
      adresse: "",
      cp: "",
      ville: "",
      mail: "",
      tel: "",
      titreEdition: "",
      cpEnCours: "",
      villeEnCours: "",
    };
  },
  watch: {
    cpEnCours(newCpEnCours) {
      this.chercheCommune(newCpEnCours);
    },
    villeEnCours(newVilleEnCours) {
      this.chercheCommune(newVilleEnCours);
    },
  },
  created: function () {
    this.$parent.$on("fermerConnexion", this.fermerConnexion);
  },
  mounted() {
    this.getAllCivilités();
    this.tabIndex = 0;
    this.mdpState = null;
    this.$store.commit("setModalClientID", "modal-connexion");
    this.$root.$on("bv::modal::shown", () => {
      // Ouverture de la fenêtre d'édition
      this.$refs.thCP.inputValue = this.user.cp;
      this.$refs.thVille.inputValue = this.user.ville;
    });
  },
  methods: {
    isNullOrWhiteSpace(str) {
      return !str || str.length === 0 || /^\s*$/.test(str);
    },

    // ===========================================
    // Fiche client
    // ===========================================
    verifieSaisieCompteClient() {
      return this.user.nom.length > 0 ? true : false;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmitCompteClient();
    },

    handleSubmitCompteClient() {
      if (!this.verifieSaisieCompteClient()) {
        return;
      }
      this.enregistreModifications();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-compteclient");
      });
    },
    dateFormatte(date) {
      let dateResult = "";
      if (date != null) {
        dateResult = new Date(date).toLocaleDateString();
      }
      return dateResult;
    },
    chercheCommune(valeur) {
      this.listeCommunes.length = 0;
      let result = "";
      let cpVille = "";
      if (valeur != "" && !this.isNullOrWhiteSpace(valeur)) {
        axios
          .get("https://vicopo.selfbuild.fr/cherche/" + valeur)
          .then((response) => {
            for (let i = 0; i < response.data.cities.length; i++) {
              cpVille =
                response.data.cities[i].code +
                " " +
                response.data.cities[i].city;
              result = this.listeCommunes.findIndex(
                (commune) => commune.codecity === cpVille
              );
              if (result === -1) {
                this.listeCommunes.push({
                  code: response.data.cities[i].code,
                  city: response.data.cities[i].city,
                  codecity: cpVille,
                });
              }
              if (i > 10) break;
            }
          });
      }
    },
    selectionListeCommune(item) {
      this.user.cp = item.code;
      this.$refs.thCP.inputValue = this.user.cp;
      this.user.ville = item.city;
      this.$refs.thVille.inputValue = this.user.ville;
    },
    getAllCivilités: function () {
      this.listeCivilités.length = 0;
      axios
        .get(apiUrl, {
          params: {
            getAllCivilite: 1,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.idCivilité = 0;
            this.civilité = "";
            Object.entries(element).forEach(([key, value]) => {
              switch (key) {
                case "0":
                case "IDCIVILITE":
                  this.idCivilité = value;
                  break;
                case "1":
                case "LIBELLE":
                  this.civilité = value;
                  break;
              }
            });
            this.listeCivilités.push({
              value: this.idCivilité,
              text: this.civilité,
            });
          });
        });
    },
    enregistreModifications() {
      if (this.user.idUser > 0) {
        // Update
        axios
          .get(apiUrl, {
            params: {
              updateClient: 1,
              id: this.user.idUser,
              idCivilité: this.user.idCivilite,
              nom: this.user.nom,
              prenom: this.user.prenom,
              adresse: this.user.adresse,
              cp: this.user.cp,
              ville: this.user.ville,
              tel: this.user.telephone,
              email: this.email,
            },
          })
          .then((response) => {
            if (response.data === "1") {
              //console.log("Modifications enregistrées");
            }
          });
      } else {
        // Insert
        axios
          .get(apiUrl, {
            params: {
              addClient: 1,
              idCivilité: this.user.idCivilite,
              nom: this.user.nom,
              prenom: this.user.prenom,
              adresse: this.user.adresse,
              cp: this.user.cp,
              ville: this.user.ville,
              tel: this.user.telephone,
              email: this.email,
              mdp: this.mdp,
            },
          })
          .then((response) => {
            if (response.data === "1") {
              this.validerConnexion();
            }
          });
      }
    },
    // ===========================================
    // Connexion
    // ===========================================
    verifieSaisie() {
      if (this.tabIndex === 0) {
        // Identification
        //this.emailState = !this.isNullOrWhiteSpace(this.email);
        this.mdpState = !this.isNullOrWhiteSpace(this.mdp);

        return this.isNullOrWhiteSpace(this.email) ||
          this.isNullOrWhiteSpace(this.mdp)
          ? false
          : true;
      } else {
        // Nouveau compte
        return this.isNullOrWhiteSpace(this.email) ||
          this.isNullOrWhiteSpace(this.mdp) ||
          this.mdp2 !== this.mdp
          ? false
          : true;
      }
    },
    handleOkConnexion(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.verifieSaisie()) {
        return;
      }
      switch (this.tabIndex) {
        case 0:
          this.validerConnexion();
          break;
        case 1:
          this.enregistrerNouveauCompte();
          break;
      }
    },
    async handleOkModifMdp() {
      if (
        !this.isNullOrWhiteSpace(this.mdpActuel) &&
        !this.isNullOrWhiteSpace(this.mdp) &&
        !this.isNullOrWhiteSpace(this.mdp2)
      ) {
        if (this.mdp2 === this.mdp) {
          const response = await axios.get(apiUrl, {
            params: {
              changeUserPwd: 1,
              email: this.email,
              mdp: this.mdpActuel,
              mdpNew: this.mdp,
            },
          });
          if (response.data === "1") {
            this.$bvModal.msgBoxOk(
              "Votre nouveau mot de passe a bien été enregistré."
            );
          } else {
            this.$bvModal.msgBoxOk(
              "Impossible de modifier votre mot de passe, veuillez vérifier la saisie de votre mot de passe actuel."
            );
          }
        } else {
          this.$bvModal.msgBoxOk(
            "Modification impossible : Le mot de passe de confirmation ne correspond pas au nouveau mot de passe."
          );
        }
      } else {
        this.$bvModal.msgBoxOk("Modification impossible : Saisie incomplète.");
      }
      this.mdpActuel = "";
      this.mdp = "";
      this.mdp2 = "";
      this.$store.commit("setModalClientID", "modal-compteclient");
    },
    handleCancelModifMdp() {
      this.$store.commit("setModalClientID", "modal-compteclient");
    },
    async enregistrerNouveauCompte() {
      let existe = await this.compteExiste();
      //console.log("existe:"+existe);
      if (existe !== "1") {
        this.$nextTick(() => {
          this.tabIndex = 0;
          this.$bvModal.show("modal-compteclient");
        });
      } else {
        this.$bvModal.msgBoxOk(
          "Impossible de créer un nouveau compte avec cette adresse mail car elle est déjà utilisée."
        );
      }
    },
    async compteExiste() {
      let existe = false;
      const response = await axios.get(apiUrl, {
        params: {
          userExists: 1,
          email: this.email,
        },
      });
      existe = response.data;

      return existe;
    },
    async genererMotDePasse() {
      console.log("genererMotDePasse");
      if (!this.compteExiste()) {
        this.$bvModal.msgBoxOk(
          "Il n'existe pas de compte avec l'adresse " + this.email
        );
        return;
      }

      let messageEnvoyé = false;
      const response = await axios.get(apiUrl, {
        params: {
          generateNewPwd: 1,
          email: this.email,
        },
      });
      messageEnvoyé = response.data;
      if (messageEnvoyé) {
        this.$bvModal.msgBoxOk(
          "Un nouveau mot de passe a été envoyé à " + this.email
        );
      } else {
        this.$bvModal.msgBoxOk("Erreur " + this.email);
      }
    },
    async listerCommandes() {
      let idCommande = 0;
      let date = "";
      const response = await axios.get(apiUrl, {
        params: {
          clientGetCommandes: 1,
          id: this.user.idUser,
        },
      });
      response.data.forEach((element) => {
        Object.entries(element).forEach(([key, value]) => {
          switch (key) {
            case "IDCOMMANDE":
            case "0":
              idCommande = value;
              break;
            case "DATE_CREATION":
            case "1":
              date = value;
              break;
          }
        });
        this.$store.commit({
          type: "addCommande",
          idCommande: idCommande,
          date: date,
        });
      });
    },
    fermerConnexion() {
      // Fonction appelée par le parent
      this.email = "";
      this.mdpActuel = "";
      this.mdp = "";
      this.mdp2 = "";
      this.user.idUser = "";
      this.user.idCivilite = "";
      this.user.civilite = "";
      this.user.nom = "";
      this.user.prenom = "";
      this.user.adresse = "";
      this.user.cp = "";
      this.user.ville = "";
      this.user.telephone = "";
      this.cpEnCours = "";
      this.villeEnCours = "";
    },
    validerConnexion() {
      this.user.idUser = "";
      this.user.idCivilite = "";
      this.user.civilite = "";
      this.user.nom = "";
      this.user.prenom = "";
      this.user.adresse = "";
      this.user.cp = "";
      this.user.ville = "";
      this.user.telephone = "";
      this.cpEnCours = "";
      this.villeEnCours = "";
      axios
        .get(apiUrl, {
          params: {
            getUser: 1,
            email: this.email,
            mdp: this.mdp,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            Object.entries(element).forEach(([key, value]) => {
              switch (key) {
                case "IDCLIENT":
                case "0":
                  this.user.idUser = value;
                  break;
                case "IDCIVILITE":
                case "1":
                  this.user.idCivilite = value;
                  break;
                case "CIVILITE":
                case "2":
                  this.user.civilite = value;
                  break;
                case "NOM":
                case "3":
                  this.user.nom = value;
                  break;
                case "PRENOM":
                case "4":
                  this.user.prenom = value;
                  break;
                case "ADRESSE":
                case "5":
                  this.user.adresse = value;
                  break;
                case "CP":
                case "6":
                  this.user.cp = value;
                  this.cpEnCours = value;
                  break;
                case "VILLE":
                case "7":
                  this.user.ville = value;
                  this.villeEnCours = value;
                  break;
                case "TELEPHONE":
                case "8":
                  this.user.telephone = value;
                  break;
              }
            });
          });
          if (this.user.idUser > 0) {
            this.mdpActuel = "";
            this.mdp = "";
            this.mdp2 = "";

            this.$store.commit("setUser", this.user);
            this.$nextTick(() => {
              this.$bvModal.hide("modal-connexion");
              this.$store.commit("setModalClientID", "modal-compteclient");
              this.listerCommandes();
            });
          } else {
            this.$bvModal.msgBoxOk("Erreur d'identification");
          }
        });
    },
  },
};
</script>